import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

import Page from 'components/Page';
import AppHeader from 'components/AppHeader';

const Home = () => (
  <>
    <AppHeader />
    <Page>
      <div className="content">
      <h1 className='title'>Le quiz des citations de la série Kaamelott</h1>
      <p>Une série de 10 citations</p>
      <p>Retrouveras tu l'auteur de chacune d'elles ?</p>
      <ul>
        <li>Une bonne réponse + 10 points</li>
        <li>Une mauvaise réponse -5 points</li>
        <li>Une demande d'aide -3 points</li>
      </ul>
      <Link to={'/quiz'}>
        <div className="button" >C'est parti !</div>
      </Link>
      </div>
    </Page>
  </>
);


export default Home;
